// extracted by mini-css-extract-plugin
export default {"userimage-uploadbutton":"configurator-web-userimage-uploadbutton","userimage-uploadbutton-nonDigital-newLogo":"configurator-web-userimage-uploadbutton-nonDigital-newLogo"};